import type { Layout } from "./Rows"
import type { FormSpec } from "./formSpec"

export function buildLayout(spec: FormSpec): Layout {
    return {
        rows: (spec.rows || []).map((r) => ({
            cols: (r.columns || []).map((c) => ({
                ...c,
                span: typeof c.width === "number" ? c.width : 12,
            })),
        })),
    }
}